export default "__VITE_ASSET__CdNDXcoh__"